export enum ObservationStatusEnum {
    Open = 'OPEN',
    Closed = 'CLOSED',
    Archived = 'ARCHIVED'
}